export const decimalToDegreesMinutes = (decimalDegree) => {
  const degrees = Math.floor(decimalDegree);
  const minutesDecimal = (decimalDegree - degrees) * 60;
  const minutes = Math.floor(minutesDecimal);
  // const seconds = Math.round((minutesDecimal - minutes) * 60);

  return `${degrees}° ${minutes}'`;
};
